import {
  REQUEST_PURCHASE_ORDERS,
  REQUEST_PURCHASE_ORDERS_BY_FILTER,
  FETCH_PURCHASE_ORDERS_SUCCESS,
  FETCH_PURCHASE_ORDERS_FAILURE,
  SELECT_PURCHASE_ORDER,
  RESET_CURRENT_PURCHASE_ORDER,
  REQUEST_PURCHASE_ORDER_DETAIL,
  FETCH_PURCHASE_ORDER_DETAIL_SUCCESS,
  FETCH_PURCHASE_ORDER_DETAIL_FAILURE,
  REQUEST_CREATING_PURCHASE_ORDER,
  CREATE_PURCHASE_ORDER_SUCCESS,
  CREATE_PURCHASE_ORDER_FAILURE,
  REQUEST_EDITING_PURCHASE_ORDER,
  EDIT_PURCHASE_ORDER_SUCCESS,
  EDIT_PURCHASE_ORDER_FAILURE,
  REQUEST_PURCHASE_ORDERS_NOT_RECEIVED,
  FETCH_PURCHASE_ORDERS_NOT_RECEIVED_SUCCESS,
  FETCH_PURCHASE_ORDERS_NOT_RECEIVED_FAILURE,
  REQUEST_TOTAL_PURCHASES,
  FETCH_TOTAL_PURCHASES_SUCCESS,
  FETCH_TOTAL_PURCHASES_FAILURE,
  REQUEST_TODAYS_INCOMING_ORDERS,
  FETCH_TODAYS_INCOMING_ORDERS_SUCCESS,
  FETCH_TODAYS_INCOMING_ORDERS_FAILURE,
  COPY_PURCHASE_ORDER,
  COPY_PURCHASE_ORDER_SUCCESS,
  COPY_PURCHASE_ORDER_FAILURE,
  REQUEST_PRINT_PURCHASE_ORDER,
  PRINT_PURCHASE_ORDER_SUCCESS,
  PRINT_PURCHASE_ORDER_FAILURE,
  REQUEST_DELETE_PURCHASE_ORDER,
  DELETE_PURCHASE_ORDER_SUCCESS,
  DELETE_PURCHASE_ORDER_FAILURE,
  REQUEST_PURCHASE_ORDER_PERFORMANCE,
  FETCH_PURCHASE_ORDER_PERFORMANCE_SUCCESS,
  FETCH_PURCHASE_ORDER_PERFORMANCE_FAILURE,
  REQUEST_PURCHASE_MANAGER_INFO,
  FETCH_PURCHASE_MANAGER_INFO_SUCCESS,
  FETCH_PURCHASE_MANAGER_INFO_FAILURE,
  REQUEST_LAST_MONTH_PERFORMANCE,
  FETCH_LAST_MONTH_PERFORMANCE_SUCCESS,
  FETCH_LAST_MONTH_PERFORMANCE_FAILURE,
  REQUEST_PURCHASERS_PERFORMANCE,
  FETCH_PURCHASERS_PERFORMANCE_SUCCESS,
  FETCH_PURCHASERS_PERFORMANCE_FAILURE,
  REQUEST_PRESIDENT_DASH_INFO,
  FETCH_PRESIDENT_DASH_INFO_SUCCESS,
  FETCH_PRESIDENT_DASH_INFO_FAILURE,
  REQUEST_OVERALL_PURCHASE_PERFORMANCE,
  FETCH_OVERALL_PURCHASE_PERFORMANCE_SUCCESS,
  FETCH_OVERALL_PURCHASE_PERFORMANCE_FAILURE,
  REQUEST_INCIDENT_REPORT,
  FETCH_INCIDENT_REPORT_SUCCESS,
  FETCH_INCIDENT_REPORT_FAILURE,
  REQUEST_PURCHASE_ORDER_LIST,
  FETCH_PURCHASE_ORDER_LIST_SUCCESS,
  FETCH_PURCHASE_ORDER_LIST_FAILURE,
  SET_PURCHASE_ORDERS_FILTER,
  REQUEST_PURCHASING_PERFORMANCE,
  REQUEST_PURCHASING_PERFORMANCE_BY_FILTER,
  FETCH_PURCHASING_PERFORMANCE_SUCCESS,
  FETCH_PURCHASING_PERFORMANCE_FAILURE,
  REQUEST_PURCHASING_PERFORMANCE_BY_FILTER_GFD,
  FETCH_PURCHASING_PERFORMANCE_SUCCESS_GFD,
  REQUEST_PRICE_ADJUSTMENT,
  FETCH_PRICE_ADJUSTMENT_SUCCESS,
  FETCH_PRICE_ADJUSTMENT_FAILURE,
  CREATE_PRICE_ADJUSTMENT,
  CREATE_PRICE_ADJUSTMENT_SUCCESS,
  CREATE_PRICE_ADJUSTMENT_FAILURE,
  REQUEST_PURCHASE_PIVOT_CHART_ORDERS,
  FETCH_PURCHASE_PIVOT_CHART_ORDERS_SUCCESS,
  FETCH_PURCHASE_PIVOT_CHART_ORDERS_FAILURE,
  REQUEST_PURCHASE_PIVOT_CHARTS,
  FETCH_PURCHASE_PIVOT_CHARTS_SUCCESS,
  FETCH_PURCHASE_PIVOT_CHARTS_FAILURE,
  REQUEST_PURCHASE_PIVOT_CHARTS_DETAIL,
  FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_SUCCESS,
  FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_FAILURE,
  SET_PURCHASE_PIVOT_ID,
  RESET_PURCHASE_PIVOT_CHARTS,
  CREATE_PURCHASE_PIVOT_CHART,
  CREATE_PURCHASE_PIVOT_CHART_SUCCESS,
  CREATE_PURCHASE_PIVOT_CHART_FAILURE,
  DUPLICATE_PURCHASE_PIVOT_CHART,
  DUPLICATE_PURCHASE_PIVOT_CHART_SUCCESS,
  DUPLICATE_PURCHASE_PIVOT_CHART_FAILURE,
  REQUEST_PURCHASING_REFERENCE,
  FETCH_PURCHASING_REFERENCE_SUCCESS,
  FETCH_PURCHASING_REFERENCE_FAILURE,

  CLEAR_DUPLICATED_PURCHASE_PIVOT_CHART,
  REQUEST_PURCHASE_PAYMENT_NOT_PAID,
  FETCH_PURCHASE_PAYMENT_NOT_PAID_SUCCESS,
  FETCH_PURCHASE_PAYMENT_NOT_PAID_FAILURE,
  REQUEST_PURCHASING_PERFORMANCE_BY_PRODUCT,
  FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_SUCCESS,
  FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_FAILURE,

  REQUEST_PURCHASE_PRODUCT_BY_ID,
  FETCH_PURCHASE_PRODUCT_BY_ID_SUCCESS,
  FETCH_PURCHASE_PRODUCT_BY_ID_FAILURE,

  MERGE_PURCHASE_ORDERS_LOADING,
  MERGE_PURCHASE_ORDERS_SUCCESS,
  MERGE_PURCHASE_ORDERS_ERROR,
} from '../actions/type';
import {
  isVAK
} from '../actions/root_url';

const INITIAL_STATE = {
  all: null,
  currentPurchaseOrder: null,
  currentPurchaseOrderDetail: null,
  isLoading: true,
  error: null,
  detailIsLoading: false,
  detailError: null,
  purchaseOrderIsCreating: false,
  purchaseOrderCreateError: null,
  purchaseOrderCreated: null,
  purchaseOrderIsCopying: false,
  purchaseOrderCopyError: null,
  purchaseOrderCopied: false,
  purchaseOrderIsEditing: false,
  purchaseOrderEditError: null,
  purchaseOrderEdited: false,
  numPurchaseOrdersNotReceived: null,
  numPurchaseOrdersNotReceivedLoading: null,
  numPurchaseOrdersNotReceivedError: null,
  numTotalPurchases: null,
  numTotalPurchasesLoading: null,
  numTotalPurchasesError: null,
  todaysIncomingOrders: [],
  todaysIncomingOrdersIsLoading: null,
  todaysIncomingOrdersError: null,
  purchaseOrderIsDeleting: false,
  purchaseOrderDeleteError: null,
  purchaseOrderIsDeleted: false,
  purchaseOrderPerformance: [],
  purchaseOrderPerformanceIsLoading: false,
  purchaseOrderPerformanceError: null,
  purchaseManagerInfo: {},
  purchaseManagerInfoIsLoading: false,
  purchaseManagerInfoError: null,
  lastMonth: [],
  lastMonthIsLoading: false,
  lastMonthError: null,
  purchasersPerformance: [],
  purchasersPerformanceIsLoading: false,
  purchasersPerformanceError: null,
  presidentInfo: {},
  presidentInfoIsLoading: false,
  presidentInfoError: null,
  overallPurchases: [],
  overallPurchasesIsLoading: false,
  overallPurchasesError: null,
  incidentReport: [],
  incidentReportIsLoading: false,
  incidentReportError: null,
  purchaseOrderList: [],
  purchaseOrderListIsLoading: false,
  purchaseOrderListError: null,
  purchaseOrdersFilter: null,
  purchasingPerformanceIsLoading: false,
  purchasingPerformance: null,
  purchasingPerformanceError: null,
  purchasingPerformanceByProducts: null,
  priceAdjustmentIsLoading: false,
  priceAdjustment: null,
  priceAdjustmentError: null,
  purchasePivotChartOrdersIsLoading: false,
  purchasePivotChartOrders: null,
  purchasePivotChartOrdersError: null,
  purchasePivotChartsIsLoading: false,
  purchasePivotCharts: null,
  purchasePivotChartsError: null,
  purchasePivotChartsDetailIsLoading: false,
  purchasePivotChartsDetail: null,
  purchasePivotChartsDetailError: null,
  purchasePivot_id: null,
  isDuplicatingPurchasePivotChart: false,
  duplicatedPurchasePivotChart: false,
  duplicatePurchasePivotChartError: null,
  duplicatedPurchasePivotChart: null,
  duplicatePurchasePivotChartError: null,
  purchaseReferenceReportIsLoading: false,
  purchaseReferenceReport: null,
  purchaseReferenceReportError: null,
  numPurchaseOrdersNotPaid: null,
  numPurchaseOrdersNotPaidLoading: null,
  numPurchaseOrdersNotPaidError: null,
  purchaseOrderPerformanceByProduct: [],
  purchaseOrderPerformanceByProductIsLoading: false,
  purchaseOrderPerformanceByProductError: null,
  purchaseOrderProduct: null,
  purchaseOrderProductIsLoading: false,
  purchaseOrderProductError: null,
  mergePurchaseOrderLoading: false,
  mergePurchaseOrderSuccess: false,
  mergePurchaseOrderError: '',
  mergePurchaseOrderData: [],
  grandTotal: 0,
  totalWT: 0,
  totalQTY: 0,
  quoteLoading: false,
  quoteError: null,
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    // Product action handlers
    case REQUEST_PURCHASE_ORDERS_BY_FILTER:
      return {
        ...state, all: null, error: null, isLoading: isVAK ? false : true,
      };
    case REQUEST_PURCHASE_ORDERS:
      return {
        ...state, all: null, error: null, isLoading: true,
      };
    case FETCH_PURCHASE_ORDERS_SUCCESS:
      return {
        ...state,
        all: (action.payload.data && action.payload.data.purchase_orders) ? action.payload.data.purchase_orders : action.payload.data,
        error: null,
        isLoading: false,
        totalPages: action.payload.data ? action.payload.data.totalPages : 1,
        totalRows: action.payload.data ? action.payload.data.rows : 0,
        grandTotal: action.payload.data ? action.payload.data.total : 0,
        totalWT: action.payload.data ? action.payload.data.totalweight : 0,
        totalQTY: action.payload.data ? action.payload.data.totalQty : 0,
      };
    case FETCH_PURCHASE_ORDERS_FAILURE:
      const error = action.payload || { message: action.payload.message };
      return {
        ...state, all: null, error, isLoading: false,
      };
    case SELECT_PURCHASE_ORDER:
      return {
        ...state, currentPurchaseOrder: action.payload, currentPurchaseOrderDetail: null, purchaseOrderEditError: null, purchaseOrderCreateError: null,
      };
    case RESET_CURRENT_PURCHASE_ORDER:
      return {
        ...state, currentPurchaseOrder: null, currentPurchaseOrderDetail: null, purchaseOrderEditError: null, purchaseOrderCreateError: null, purchaseOrderCreated: null, purchaseOrderEdited: null,
      };
    case REQUEST_PURCHASE_ORDER_DETAIL:
      return { ...state, detailError: null, detailIsLoading: true };
    case FETCH_PURCHASE_ORDER_DETAIL_SUCCESS:// return list of posts and make loading = false
      return {
        ...state, currentPurchaseOrderDetail: action.payload, detailError: null, detailIsLoading: false,
      };
    case FETCH_PURCHASE_ORDER_DETAIL_FAILURE:// return error and make loading = false
      const detailError = action.payload || { message: action.payload.message };// 2nd one is network or server down errors
      return {
        ...state, all: [], detailError, detailIsLoading: false,
      };
    case REQUEST_CREATING_PURCHASE_ORDER:
      return {
        ...state, purchaseOrderIsCreating: true, purchaseOrderCreateError: null, purchaseOrderCreated: null, purchaseOrderEdited: null,
      };
    case CREATE_PURCHASE_ORDER_SUCCESS:
      return {
        ...state, purchaseOrderIsCreating: false, purchaseOrderCreateError: null, purchaseOrderCreated: action.payload.data,
      };
    case CREATE_PURCHASE_ORDER_FAILURE:
      const purchaseOrderCreateError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
      return {
        ...state, purchaseOrderIsCreating: false, purchaseOrderCreateError, purchaseOrderCreated: null,
      };
    case COPY_PURCHASE_ORDER:
      return {
        ...state, purchaseOrderIsCopying: true, purchaseOrderCopyError: null, purchaseOrderCopied: false,
      };
    case COPY_PURCHASE_ORDER_SUCCESS:
      return {
        ...state, purchaseOrderIsCopying: false, purchaseOrderCopyError: null, purchaseOrderCopied: true,
      };
    case COPY_PURCHASE_ORDER_FAILURE:
      const purchaseOrderCopyError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
      return {
        ...state, purchaseOrderIsCopying: false, purchaseOrderCopyError, purchaseOrderCopied: false,
      };
    case REQUEST_EDITING_PURCHASE_ORDER:
      return {
        ...state, purchaseOrderIsEditing: true, purchaseOrderEditError: null, purchaseOrderEdited: false, purchaseOrderCreated: null,
      };
    case EDIT_PURCHASE_ORDER_SUCCESS:
      return {
        ...state, purchaseOrderIsEditing: false, purchaseOrderEditError: null, purchaseOrderEdited: true,
      };
    case EDIT_PURCHASE_ORDER_FAILURE:
      const purchaseOrderEditError = action.payload.data || { message: action.payload.message }; // 2nd term stands for network or server down errors
      return {
        ...state, purchaseOrderIsEditing: false, purchaseOrderEditError, purchaseOrderEdited: false,
      };
    case REQUEST_PURCHASE_ORDERS_NOT_RECEIVED:
      return { ...state, numPurchaseOrdersNotReceivedError: null, numPurchaseOrdersNotReceivedLoading: true };
    case FETCH_PURCHASE_ORDERS_NOT_RECEIVED_SUCCESS:
      return { ...state, numPurchaseOrdersNotReceived: action.payload.data.number, numPurchaseOrdersNotReceivedLoading: false };
    case FETCH_PURCHASE_ORDERS_NOT_RECEIVED_FAILURE:
      return { ...state, numPurchaseOrdersNotReceivedError: action.payload.data, numPurchaseOrdersNotReceivedLoading: false };
    case REQUEST_TOTAL_PURCHASES:
      return { ...state, numTotalPurchasesError: null, numTotalPurchasesLoading: true };
    case FETCH_TOTAL_PURCHASES_SUCCESS:
      return { ...state, numTotalPurchases: action.payload.data.number, numTotalPurchasesLoading: false };
    case FETCH_TOTAL_PURCHASES_FAILURE:
      return { ...state, numTotalPurchasesError: action.payload.data, numTotalPurchasesLoading: false };
    case REQUEST_TODAYS_INCOMING_ORDERS:
      return { ...state, todaysIncomingOrdersIsLoading: true, todaysIncomingOrdersError: null };
    case FETCH_TODAYS_INCOMING_ORDERS_SUCCESS:
      return { ...state, todaysIncomingOrders: action.payload.data, todaysIncomingOrdersIsLoading: false };
    case FETCH_TODAYS_INCOMING_ORDERS_FAILURE:
      const todaysIncomingOrdersError = action.payload.data || { messate: action.payload.message };
      return { ...state, todaysIncomingOrdersError, todaysIncomingOrdersIsLoading: false };
    case REQUEST_PRINT_PURCHASE_ORDER:
      return {
        ...state, purchaseOrderIsPrinting: true, purchaseOrderPrintError: null, purchaseOrderIsPrinted: null,
      };
    case PRINT_PURCHASE_ORDER_SUCCESS:
      return {
        ...state, purchaseOrderIsPrinting: false, purchaseOrderPrintError: null, purchaseOrderIsPrinted: action.payload.data,
      };
    case PRINT_PURCHASE_ORDER_FAILURE:
      const purchaseOrderPrintError = action.payload.data || { message: action.payload.message };
      return {
        ...state, purchaseOrderIsPrinting: false, purchaseOrderPrintError, purchaseOrderIsPrinted: null,
      };
    case REQUEST_DELETE_PURCHASE_ORDER:
      return {
        ...state, purchaseOrderIsDeleting: true, purchaseOrderDeleteError: null, purchaseOrderIsDeleted: false,
      };
    case DELETE_PURCHASE_ORDER_SUCCESS:
      return {
        ...state, purchaseOrderIsDeleting: false, purchaseOrderDeleteError: null, purchaseOrderIsDeleted: true,
      };
    case DELETE_PURCHASE_ORDER_FAILURE:
      const purchaseOrderDeleteError = action.payload.data || { messate: action.payload.message };
      return {
        ...state, purchaseOrderIsDeleting: false, purchaseOrderDeleteError, purchaseOrderIsDeleted: false,
      };
    case REQUEST_PURCHASE_ORDER_PERFORMANCE:
      return { ...state, purchaseOrderPerformanceIsLoading: true, purchaseOrderPerformanceError: null };
    case FETCH_PURCHASE_ORDER_PERFORMANCE_SUCCESS:
      return { ...state, purchaseOrderPerformanceIsLoading: false, purchaseOrderPerformance: action.payload.data };
    case FETCH_PURCHASE_ORDER_PERFORMANCE_FAILURE:
      const purchaseOrderPerformanceError = action.payload.data || { message: action.payload.message };
      return { ...state, purchaseOrderPerformanceIsLoading: false, purchaseOrderPerformanceError };
    case REQUEST_PURCHASE_MANAGER_INFO:
      return {
        ...state, purchaseManagerInfoIsLoading: true, purchaseManagerInfo: null, purchaseManagerInfoError: null,
      };
    case FETCH_PURCHASE_MANAGER_INFO_SUCCESS:
      return { ...state, purchaseManagerInfoIsLoading: false, purchaseManagerInfo: action.payload.data };
    case FETCH_PURCHASE_MANAGER_INFO_FAILURE:
      const purchaseManagerInfoError = action.payload.data || { message: action.payload.message };
      return { ...state, purchaseManagerInfoIsLoading: false, purchaseManagerInfoError };
    case REQUEST_LAST_MONTH_PERFORMANCE:
      return {
        ...state, lastMonthIsLoading: true, lastMonth: [], lastMonthError: null,
      };
    case FETCH_LAST_MONTH_PERFORMANCE_SUCCESS:
      return { ...state, lastMonthIsLoading: false, lastMonth: action.payload.data };
    case FETCH_LAST_MONTH_PERFORMANCE_FAILURE:
      const lastMonthError = action.payload.data || { message: action.payload.message };
      return { ...state, lastMonthIsLoading: false, lastMonthError };
    case REQUEST_PURCHASERS_PERFORMANCE:
      return {
        ...state, purchasersPerformanceIsLoading: true, purchasersPerformance: [], purchasersPerformanceError: null,
      };
    case FETCH_PURCHASERS_PERFORMANCE_SUCCESS:
      return { ...state, purchasersPerformanceIsLoading: false, purchasersPerformance: action.payload.data };
    case FETCH_PURCHASERS_PERFORMANCE_FAILURE:
      const purchasersPerformanceError = action.payload.data || { message: action.payload.message };
      return { ...state, purchasersPerformanceIsLoading: false, purchasersPerformanceError };
    case REQUEST_PRESIDENT_DASH_INFO:
      return {
        ...state, presidentInfoIsLoading: true, presidentInfo: {}, presidentInfoError: null,
      };
    case FETCH_PRESIDENT_DASH_INFO_SUCCESS:
      return { ...state, presidentInfoIsLoading: false, presidentInfo: action.payload.data };
    case FETCH_PRESIDENT_DASH_INFO_FAILURE:
      const presidentInfoError = action.payload.data || { message: action.payload.message };
      return { ...state, presidentInfoIsLoading: false, presidentInfoError };
    case REQUEST_OVERALL_PURCHASE_PERFORMANCE:
      return {
        ...state, overallPurchasesIsLoading: true, overallPurchasesError: null, overallPurchases: [],
      };
    case FETCH_OVERALL_PURCHASE_PERFORMANCE_SUCCESS:
      return { ...state, overallPurchasesIsLoading: false, overallPurchases: action.payload.data };
    case FETCH_OVERALL_PURCHASE_PERFORMANCE_FAILURE:
      const overallPurchasesError = action.payload.data || { message: action.payload.message };
      return { ...state, overallPurchasesIsLoading: false, overallPurchasesError };
    case REQUEST_INCIDENT_REPORT:
      return {
        ...state, incidentReportIsLoading: true, incidentReport: [], incidentReportError: null,
      };
    case FETCH_INCIDENT_REPORT_SUCCESS:
      return { ...state, incidentReportIsLoading: false, incidentReport: action.payload.data };
    case FETCH_INCIDENT_REPORT_FAILURE:
      const incidentReportError = action.payload.data || { message: action.payload.message };
      return { ...state, incidentReportIsLoading: false, incidentReportError };
    case REQUEST_PURCHASE_ORDER_LIST:
      return {
        ...state, purchaseOrderListIsLoading: true, purchaseOrderList: [], purchaseOrderListError: null,
      };
    case FETCH_PURCHASE_ORDER_LIST_SUCCESS:
      return { ...state, purchaseOrderListIsLoading: false, purchaseOrderList: action.payload.data };
    case FETCH_PURCHASE_ORDER_LIST_FAILURE:
      const purchaseOrderListError = action.payload.data || { message: action.payload.message };
      return { ...state, purchaseOrderListIsLoading: false, purchaseOrderListError };
    case SET_PURCHASE_ORDERS_FILTER:
      return { ...state, purchaseOrdersFilter: action.payload };
    case REQUEST_PURCHASING_PERFORMANCE:
    case REQUEST_PURCHASING_PERFORMANCE_BY_FILTER:
      return {
        ...state, purchasingPerformanceIsLoading: true, purchasingPerformance: null, purchasingPerformanceError: null,
      };
    case FETCH_PURCHASING_PERFORMANCE_SUCCESS:
      return {
        ...state, purchasingPerformanceIsLoading: false, purchasingPerformance: action.payload.data, purchasingPerformanceError: null,
      };
    case FETCH_PURCHASING_PERFORMANCE_FAILURE:
      const purchasingPerformanceError = action.payload.data || { message: action.payload.message };
      return {
        ...state, purchasingPerformanceIsLoading: false, purchasingPerformance: null, purchasingPerformanceError,
      };
      case REQUEST_PURCHASING_PERFORMANCE_BY_FILTER_GFD:
        return {
          ...state, purchasingPerformanceIsLoading: true, purchasingPerformance: null, purchasingPerformanceError: null,
        };
      case FETCH_PURCHASING_PERFORMANCE_SUCCESS_GFD:
        return {
          ...state, purchasingPerformanceIsLoading: false, purchasingPerformanceByProducts: action.payload.data, purchasingPerformanceError: null,
        };
    case REQUEST_PRICE_ADJUSTMENT:
      return {
        ...state, priceAdjustmentIsLoading: true, priceAdjustment: null, priceAdjustmentError: null,
      };
    case FETCH_PRICE_ADJUSTMENT_SUCCESS:
      return {
        ...state, priceAdjustmentIsLoading: false, priceAdjustment: action.payload.data, priceAdjustmentError: null,
      };
    case FETCH_PRICE_ADJUSTMENT_FAILURE:
      const priceAdjustmentError = action.payload.data || { message: action.payload.message };
      return {
        ...state, priceAdjustmentIsLoading: false, priceAdjustment: null, priceAdjustmentError,
      };
    case REQUEST_PURCHASE_PIVOT_CHART_ORDERS:
      return {
        ...state, purchasePivotChartOrdersIsLoading: true, purchasePivotChartOrders: null, purchasePivotChartOrdersError: null,
      };
    case FETCH_PURCHASE_PIVOT_CHART_ORDERS_SUCCESS:
      return {
        ...state, purchasePivotChartOrdersIsLoading: false, purchasePivotChartOrders: action.payload.data, purchasePivotChartOrdersError: null,
      };
    case FETCH_PURCHASE_PIVOT_CHART_ORDERS_FAILURE:
      const purchasePivotChartOrdersError = action.payload.data || { message: action.payload.message };
      return {
        ...state, purchasePivotChartOrdersIsLoading: false, purchasePivotChartOrders: null, purchasePivotChartOrdersError,
      };
    case REQUEST_PURCHASE_PIVOT_CHARTS:
      return {
        ...state, purchasePivotChartsIsLoading: true, purchasePivotCharts: null, purchasePivotChartsError: null,
      };
    case FETCH_PURCHASE_PIVOT_CHARTS_SUCCESS:
      return {
        ...state, purchasePivotChartsIsLoading: false, purchasePivotCharts: action.payload.data, purchasePivotChartsError: null,
      };
    case FETCH_PURCHASE_PIVOT_CHARTS_FAILURE:
      const purchasePivotChartsError = action.payload.data || { message: action.payload.message };
      return {
        ...state, purchasePivotChartsIsLoading: false, purchasePivotCharts: null, purchasePivotChartsError,
      };
    case REQUEST_PURCHASE_PIVOT_CHARTS_DETAIL:
      return {
        ...state, purchasePivotChartsDetailIsLoading: true, purchasePivotChartsDetail: null, purchasePivotChartsDetailError: null,
      };
    case FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_SUCCESS:
      return {
        ...state, purchasePivotChartsDetailIsLoading: false, purchasePivotChartsDetail: action.payload.data, purchasePivotChartsDetailError: null,
      };
    case FETCH_PURCHASE_PIVOT_CHARTS_DETAIL_FAILURE:
      const purchasePivotChartsDetailError = action.payload.data || { message: action.payload.message };
      return {
        ...state, purchasePivotChartsDetailIsLoading: false, purchasePivotChartsDetail: null, purchasePivotChartsDetailError,
      };
    case RESET_PURCHASE_PIVOT_CHARTS:
      return { ...state, purchasePivotChartsDetail: null };
    case SET_PURCHASE_PIVOT_ID:
      return { ...state, purchasePivot_id: action.payload };
    case DUPLICATE_PURCHASE_PIVOT_CHART:
      return {
        ...state, isDuplicatingPurchasePivotChart: true, duplicatedPurchasePivotChart: false, duplicatePurchasePivotChartError: null,
      };
    case DUPLICATE_PURCHASE_PIVOT_CHART_SUCCESS:
      return {
        ...state, isDuplicatingPurchasePivotChart: false, duplicatedPurchasePivotChart: true, duplicatePurchasePivotChartError: null,
      };
    case DUPLICATE_PURCHASE_PIVOT_CHART_FAILURE:
      const duplicatePurchasePivotChartError = action.payload.data || { message: action.payload.message };
      return {
        ...state, isDuplicatingPurchasePivotChart: false, duplicatedPurchasePivotChart: false, duplicatePurchasePivotChartError,
      };
    case CLEAR_DUPLICATED_PURCHASE_PIVOT_CHART:
      return {
        ...state, isDuplicatingPurchasePivotChart: false, duplicatedPurchasePivotChart: false, duplicatePurchasePivotChartError: null,
      };
    case REQUEST_PURCHASING_REFERENCE:
      return {
        ...state, purchaseReferenceReportIsLoading: true, purchaseReferenceReport: null, purchaseReferenceReportError: null,
      };
    case FETCH_PURCHASING_REFERENCE_SUCCESS:
      return {
        ...state, purchaseReferenceReportIsLoading: false, purchaseReferenceReport: action.payload.data, purchaseReferenceReportError: null,
      };
    case FETCH_PURCHASING_REFERENCE_FAILURE:
      const purchaseReferenceReportError = action.payload.data || { message: action.payload.message };
      return {
        ...state, purchaseReferenceReportIsLoading: false, purchaseReferenceReport: null, purchaseReferenceReportError,
      };
    case REQUEST_PURCHASE_PAYMENT_NOT_PAID:
      return { ...state, numPurchaseOrdersNotPaidError: null, numPurchaseOrdersNotPaidLoading: true };
    case FETCH_PURCHASE_PAYMENT_NOT_PAID_SUCCESS:
      return { ...state, numPurchaseOrdersNotPaid: action.payload.data.payment, numPurchaseOrdersNotPaidLoading: false };
    case FETCH_PURCHASE_PAYMENT_NOT_PAID_FAILURE:
      return { ...state, numPurchaseOrdersNotPaidError: action.payload.data, numPurchaseOrdersNotPaidLoading: false };
    case REQUEST_PURCHASING_PERFORMANCE_BY_PRODUCT:
      return { ...state, purchaseOrderPerformanceByProductIsLoading: true, purchaseOrderPerformanceByProductError: null };
    case FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_SUCCESS:
      return { ...state, purchaseOrderPerformanceByProductIsLoading: false, purchaseOrderPerformanceByProduct: action.payload.data };
    case FETCH_PURCHASING_PERFORMANCE_BY_PRODUCT_FAILURE:
      const purchaseOrderPerformanceByProductError = action.payload.data || { message: action.payload.message };
      return { ...state, purchaseOrderPerformanceByProductIsLoading: false, purchaseOrderPerformanceByProductError };
    case REQUEST_PURCHASE_PRODUCT_BY_ID:
      return {
        ...state, purchaseOrderProductIsLoading: true, purchaseOrderProduct: null, purchaseOrderProductError: null,
      };
    case FETCH_PURCHASE_PRODUCT_BY_ID_SUCCESS:
      return { ...state, purchaseOrderProductIsLoading: false, purchaseOrderProduct: action.payload.data };
    case FETCH_PURCHASE_PRODUCT_BY_ID_FAILURE:
      return { ...state, purchaseOrderProductIsLoading: false, purchaseOrderProductError: action.payload.data };
    case MERGE_PURCHASE_ORDERS_LOADING: 
      return { ...state, mergePurchaseOrderLoading: true, mergePurchaseOrderSuccess: false,mergePurchaseOrderError: '',
      }
    case MERGE_PURCHASE_ORDERS_SUCCESS: 
      return { ...state, mergePurchaseOrderLoading: false, mergePurchaseOrderSuccess: true,mergePurchaseOrderError: '',
      }
    case MERGE_PURCHASE_ORDERS_ERROR: 
      return { ...state, mergePurchaseOrderLoading: false, mergePurchaseOrderSuccess: false, mergePurchaseOrderError: action.payload,
      }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./master/jsx/reducers/purchaseOrders_reducer.js